export default __webpack_public_path__ + "static/media/logo.7548c8cf.svg";